<template lang="pug">
.quickChat(:class='{open: open}')
  .closeQuickChat
    i.fa.fa-times
  .discussionPane(v-if='open', v-click-outside="closeModalFromClickOutside")
    chat-conversation(:users='users', v-if='show')
    .waiting.text-center.text-muted(v-else)
      template(v-if='enoughInfo')
        | {{$t('chat.quickChat.waiting')}} {{users | users}}
        br
        br
        vue-object-img(:object='user', v-for='user in users', :key='user.id')
        br
        br
        i.fa.fa-refresh.fa-spin
      template(v-else)
        | {{$t('chat.title')}}
        br
        br
        i.fa.fa-refresh.fa-spin

</template>
<script>
import ChatConversation from './ChatConversation'
import modalsBus from '@/components/shared/ModalsBus'
import VueObjectImg from '@/components/shared/VueObjectImg'
import {users} from '@/components/shared/vue.globals'

import $ from 'jquery'
import _ from 'lodash'

export default {
  data () {
    return {
      users: [],
      open: false,
      show: false
    }
  },
  components: {
    ChatConversation,
    VueObjectImg
  },
  mounted () {
    modalsBus.onOpen((arg, users) => {
      if (arg === modalsBus.modals.CHAT_WITH) {
        this.users = users
        setTimeout(() => {
          this.openModal()
        }, 50)
      } else {
        this.closeModal()
      }
    })
    modalsBus.onCloseAll(() => {
      this.closeModal()
    })
  },
  computed: {
    enoughInfo () {
      return !_.find(this.users, (u) => u.name === undefined)
    }
  },
  methods: {
    openModal () {
      this.$store.dispatch('chat/setQuickConversationUsers', this.users)
      this.$router.push({query: {m: 'quick', u: _.join(_.map(this.users, 'id'), ',')}})
      this.open = true
      this.show = false
      $('#body').addClass('quickChatOpen')
      setTimeout(() => {
        this.show = true
      }, 300)
    },
    closeModal () {
      this.open = false
      // this.users = []
      this.$store.dispatch('chat/deselectQuickConversation')
      $('#body').removeClass('quickChatOpen')
      setTimeout(() => {
        this.show = false
      }, 300)
    },
    closeModalFromClickOutside (event) {
      // ugly code but do not find another way...
      // solved problem :
      // - if chat is closed because we click on another link => do not change route (route is already changed
      // - if chat is closed beacuse we click outside without clicking on another link, change route
      // let current = this.$route.fullPath
      this.closeModal()
      // if (this.$route.fullPath === current) {
      this.$router.push({query: {}})
      // }
      // }, 500)
    }
  },
  filters: {
    users
  },
  watch: {
    $route () {
      if (this.$route.query.m === 'quick' && this.$route.query.u !== '') {
        if (_.join(_.map(this.users, 'id'), ',') === this.$route.query.u) {
          return
        }
        this.users = _.map(_.split(this.$route.query.u, ','), (id) => {
          return {id: parseInt(id), kind: 'user'}
        })
        this.openModal()
      } else {
        this.closeModal()
      }
    }
  }
}
</script>
<style lang="sass">
.quickChat
  left: -100%
  position: fixed
  top: 50px
  bottom: 0
  right: 100%
  z-index: 98
  transition: left 0.3s ease
  .closeQuickChat
    display: none
  &.open
    background-color: rgba(0,0,0,0.5)
    left: 50px
    right: 0
    @media(max-width: 550px)
      .closeQuickChat
        position: fixed
        top: 55px
        right: 10px
        display: block
        border-radius: 50%
        background-color: white
        padding: 5px
        $size: 40px
        width: $size
        height: $size
        line-height: $size - 10
        text-align: center
        box-shadow: 0px 0px 5px rgba(0,0,0,0.2)
        z-index: 300
    @media(max-width: 467px)
      left: 0
    @media(max-height: 400px)
      top: 0
      .closeQuickChat
        top: 5px
  .discussionPane
    background-color: #EEE
    box-shadow: 0px 0px 10px rgba(0,0,0,0.2)
    width: 500px
    position: relative
    height: calc(100vh - 50px)
    @media(max-width: 550px)
      width: calc(100vw - 50px)
    @media(max-width: 467px)
      width: 100vw

    .waiting
      padding: 50px
      .profileImage
        $size: 50px
        height: $size
        line-height: $size
        width: $size
</style>



// WEBPACK FOOTER //
// QuickChatConversation.vue?27ace93c